import getENV from "../../../../util/getENV";
import useSmartContract from "../../useSmartContract";

export default function useSkeleMarket() {
    //console.log('>>> useCatacombs')
    const { modules: { skeleMarket: { contract } } } = getENV();
    const { contract: skeleMarket } = useSmartContract(contract);
    return { skeleMarket }
}